import { useAppDispatch, useAppSelector } from "@/store/hooks";
import axios from "axios";
import notification from "./notification.util";
import { signOut } from "@/store/slicers/auth.slicer";

export const useApiClient = () => {
  const { token } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const instance = axios.create({
    baseURL: `${import.meta.env.VITE_API_URL}/`,
    headers,
    maxBodyLength: Infinity,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const response = error?.response;
      const status = response?.status;
      const message = response?.data?.message;
      // Module-visibility 403s are intentional access restrictions, not errors the user should be
      // nagged about (the section is hidden from them anyway). Suppress those toasts.
      const isModuleDisabled =
        status === 403 && typeof message === "string" && message.includes("disabled for your business");
      if (message && !isModuleDisabled) notification.error(message);
      if (status === 401) {
        dispatch(signOut());
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const makeParams = (params: any) => {
  Object.keys(params).forEach((k) => params[k] == null && delete params[k]);
  return params;
};
